import cx from 'classix';
import { Icon } from '../atoms';

type CarouselArrowButtonProps = {
  direction: 'left' | 'right';
  onClick: () => void;
  disabled?: boolean;
  ariaLabel: string;
};

export const CarouselArrowButton = ({
  direction,
  onClick,
  disabled = false,
  ariaLabel,
}: CarouselArrowButtonProps) => (
  <button
    type='button'
    onClick={disabled ? undefined : onClick}
    disabled={disabled}
    aria-label={ariaLabel}
    className={cx(
      'flex h-14 w-14 items-center justify-center rounded-full border border-gray-100 text-gray-400',
      disabled ? 'cursor-default opacity-50' : 'cursor-pointer hover:bg-gray-50',
    )}
  >
    <Icon type={direction === 'left' ? 'arrow-left' : 'arrow-right'} size='24' />
  </button>
);
